<template>
  <div class="address-container">
    <div>
      <b-card title="Dirección" class="mb-2">
        <b-card-text>{{ direccion.street }} {{ direccion.no_ext }}</b-card-text>
        <b-card-text>{{ direccion.suburb }} {{ direccion.cp }} </b-card-text>
        <b-card-text>{{ direccion.municipality }}</b-card-text>
        <b-card-text>{{ direccion.references }}</b-card-text>
        <button
          class="btn text-light"
          style="width: 120px; height: 45px; background: #0f182b"
          @click="editarDireccion"
        >
          Editar
        </button>
      </b-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "Address",
  props: ["direccionComponente", "editForm"],
  data() {
    return {
      direccion: this.direccionComponente,
    };
  },
  methods: {
    editarDireccion() {
      this.$emit("editForm", true, this.direccion);
    },
  },
};
</script>

<style scoped>
.address-container {
  margin: 35px;
}
</style>